import { render, staticRenderFns } from "./ElNeed.vue?vue&type=template&id=9f1a667c&scoped=true&"
import script from "./ElNeed.vue?vue&type=script&lang=js&"
export * from "./ElNeed.vue?vue&type=script&lang=js&"
import style0 from "./ElNeed.vue?vue&type=style&index=0&id=9f1a667c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1a667c",
  null
  
)

export default component.exports